// extracted by mini-css-extract-plugin
export default {"button":"button_button__4-vvU","buttonSmall":"button_buttonSmall__tSE1p button_button__4-vvU","buttonTransparent":"button_buttonTransparent__T7POr"};